export enum DBLocalTheme {
    BLUE_THEME = 'BLUE_THEME',
    AQUA_THEME = 'AQUA_THEME',
    PURPLE_THEME = 'PURPLE_THEME',
    GREEN_THEME = 'GREEN_THEME',
    CYAN_THEME = 'CYAN_THEME',
    ORANGE_THEME = 'ORANGE_THEME',
    DARK_BLUE_THEME = 'DARK_BLUE_THEME',
    DARK_AQUA_THEME = 'DARK_AQUA_THEME',
    DARK_PURPLE_THEME = 'DARK_PURPLE_THEME',
    DARK_GREEN_THEME = 'DARK_GREEN_THEME',
    DARK_CYAN_THEME = 'DARK_CYAN_THEME',
    DARK_ORANGE_THEME = 'DARK_ORANGE_THEME',
}